import { useEffect, useMemo, useState } from 'react';
import { db } from '../../firebase';
import { doc, onSnapshot } from 'firebase/firestore';

export interface ActivePriceListDoc {
  priceListId: string;
  downloadUrl: string;
  versionNumber: number;
  updatedAt: any;
}

/**
 * [배경] 항상 최신 단가표를 노출하기 위한 실시간 구독 훅
 * - Firestore settings/default_documents/active/price_list 문서 구독
 * - Storage 캐시를 고려하여 ?v=<updatedAt> 쿼리로 강제 최신화
 */
export function useActivePriceList() {
  const [data, setData] = useState<ActivePriceListDoc | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    const ref = doc(db, 'settings/default_documents');
    const unsub = onSnapshot(
      ref,
      (snap) => {
        setLoading(false);
        if (!snap.exists() || !snap.data()?.active_price_list?.v1) {
          setData(null);
          return;
        }
        const d = snap.data()?.active_price_list?.v1 as ActivePriceListDoc;
        setData(d);
      },
      (err) => {
        setLoading(false);
        setError(err?.message || '구독 실패');
        // TODO: enqueueSnackbar 연결 가능
        // console.error(err);
      }
    );
    return () => unsub();
  }, []);

  const urlWithCacheBust = useMemo(() => {
    if (!data?.downloadUrl) return '';
    const updated = data.updatedAt?.toMillis ? data.updatedAt.toMillis() : Number(new Date(data.updatedAt).getTime());
    const v = isNaN(updated) ? data.versionNumber : updated;
    const sep = data.downloadUrl.includes('?') ? '&' : '?';
    return `${data.downloadUrl}${sep}v=${v}`;
  }, [data]);

  return { data, url: urlWithCacheBust, loading, error };
}


